import { render, staticRenderFns } from "./ProductsColComponent.vue?vue&type=template&id=2b7d43fc"
import script from "./ProductsColComponent.vue?vue&type=script&lang=js"
export * from "./ProductsColComponent.vue?vue&type=script&lang=js"
import style0 from "./ProductsColComponent.vue?vue&type=style&index=0&id=2b7d43fc&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports